// 元は pages/job_category/tohan/positions/show.jsなど、共通処理でいいので場所移動
import mapboxEmbed from '@component_path/shared/mapboxEmbed';
import { registerPositionBookmarkHandler } from '@component_path/shared/positionBookmark';

document.addEventListener('DOMContentLoaded', () => {
  mapboxEmbed();
  registerPositionBookmarkHandler();
  // lazyloadの読み込み
  $("img").lazyload();
});